module.exports = __webpack_public_path__ + "img/BeccaPalette3.32522d1b.jpg";